import {combineReducers} from 'redux';
import user from './user';

export default combineReducers({
    user
})


// WEBPACK FOOTER //
// ./src/pages/sign/reducers/index.js